/*
 * des 特色资源push稿快速预览的右侧
 * date 2018-01-17
 * author lileilei
 */
angular.module('pushPrevDetailModule', [])
    .directive('pushPrevDetail', ["$state", "$q", "$location", "$timeout", '$stateParams', 'trsHttpService', 'trsspliceString', 'resourceCenterService', 'modalDialog', 'resCtrModalService', 'storageListenerService',
        function($state, $q, $location, $timeout, $stateParams, trsHttpService, trsspliceString, resourceCenterService, modalDialog, resCtrModalService, storageListenerService) {
            return {
                scope: {
                    rebuildData: '='
                },
                restrict: 'AE',
                templateUrl: './networkResource/featuredResource/push/quickPreview/detail/detail.html',
                replace: true,
                link: function(scope, iElm, iAttrs, controller) {
                    initStatus();
                    initData();
                    /**
                     * [initStatus description]状态初始化
                     * @return {[type]} [description]
                     */
                    function initStatus() {
                        scope.status = {
                            currModule: "appPush",
                        };
                        scope.basicParams = {
                            channelName: scope.status.currModule,
                            typeName: $stateParams.typename,
                            nodeId: $stateParams.nodeid
                        };
                        scope.detailData = [];
                    }
                    /**
                     * [initData description]初始化数据
                     * @return {[type]} [description]
                     */
                    function initData() {
                        if (angular.isDefined(scope.rebuildData)) {
                            getCurrentLoginUser().then(function() {
                                requestData();
                            });
                        }
                    }
                    /**
                     * [getCurrentLoginUser description]获取当前用户
                     * @return {[type]} [description]
                     */
                    function getCurrentLoginUser() {
                        var deferred = $q.defer();
                        var userParams = {
                            serviceid: "mlf_extuser",
                            methodname: "findUserInfo"
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), userParams, "post").then(function(data) {
                            scope.user = data[0];
                            deferred.resolve(scope.user.ID);
                        });
                        return deferred.promise;
                    }
                    /**
                     * [requestData description]获取数据
                     * @return {[type]} [description]
                     */
                    function requestData() {
                        var params = {
                            "typeid": "zyzx",
                            "serviceid": "appPush",
                            "modelid": "detailData",
                            "user_id": '',
                            'indexName': 'app_message_push_formal',
                            'isDetail': false,
                            'typeName': 'push',
                            "guid": scope.rebuildData.guid
                        };
                        params.user_id = scope.user.ID;
                        scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                            if (data.result == "success") {
                                scope.detailData = data.content[0];
                            }
                        });
                    }
                    /**
                     * [openTakeDraftModal description]取稿
                     * @return {[type]} [description]
                     */
                    scope.openTakeDraftModal = function() {
                        var params = {
                            serviceid: "mlf_bigdataexchange",
                            methodname: "fetch",
                            guid: scope.rebuildData.guid,
                            indexName: "app_message_push_formal",
                            channelName: scope.status.currModule
                                // IsRobot: true
                        };
                        var modalInstance = resCtrModalService.fullTakeDraft(params, false, [scope.rebuildData]);
                        modalInstance.result.then(function(data) {
                            takeDraftDownloadImgs(data).then(function() {
                                storageListenerService.addListenerToResource("takeDraft");
                            });
                        }, function() {});
                    };
                    /**
                     * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
                     * @param  {[type]} data [description]
                     * @return {[type]}      [description]
                     */
                    function takeDraftDownloadImgs(data) {
                        var deferred = $q.defer();
                        var needDownloadImg = false;
                        for (var i = 0; i < data.REPORTS.length; i++) {
                            if (data.REPORTS[i].PICERROR == 1) {
                                needDownloadImg = true;
                                break;
                            }
                        }
                        if (needDownloadImg) {
                            resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                                deferred.resolve();
                            });
                        } else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }
                    //个人素材
                    /*scope.creationAxis = function() {
                        var params = angular.copy(scope.basicParams);
                        params.guid = scope.rebuildData.guid;
                        params.indexName = scope.rebuildData.indexName;
                        resourceCenterService.setBigDataCreation(params).then(function(data) {
                            modalDialog.alertType("添加成功", "", "success", false, function() {

                            });
                        });
                    };*/
                    //个人素材(稿件批量添加到个人素材)
                    scope.creationAxis = function() {
                        var params = {
                            typeid: "zyzx",
                            serviceid: "mlf_bigdataexchange",
                            methodname: "batchPersonalMaterial",
                            channelName: scope.status.currModule, //栏目名称全拼结构
                            PersonalMaterialId: 0, //所属文件夹ID，默认根节点（0）
                            indexName: "app_message_push_formal",
                            guid: scope.rebuildData.guid,
                            // IsRobot: true //机器人稿必传
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                            modalDialog.alertType("添加成功", "", "success", false, function() {

                            });
                        });
                    };
                    // 收藏
                    scope.collect = function() {
                        var params = {
                            serviceid: "mlf_bigdataexchange",
                            methodname: "collect",
                            guid: scope.rebuildData.guid,
                            indexName: "app_message_push_formal",
                            channelName: scope.status.currModule,
                            // IsRobot: true
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                            modalDialog.alertType("收藏成功!", "", "success", false, "");
                        });
                    };
                    /**
                     * [plainView description] 返回 普通视图
                     * @return {[type]} [description]
                     */
                    scope.plainView = function() {
                        $state.go("front.networksource.featuredresource.push.resource", $stateParams);
                    };
                }
            };
        }
    ]);
